import { Box, ListItem, ListItemText, ListItemIcon, Tooltip } from "@mui/material";
import { FieldIcon } from "../Field/FieldIcon";
import { TooltipBody } from "./TooltipBody";
interface Props {
  fieldName: string;
  shortDescription: string;
  fieldType: string;
  description: string;
  commonUses: string[];
  proTip: string;
  onFieldClick: () => void;
}
export const FieldItem = ({
  fieldName,
  shortDescription,
  fieldType,
  description,
  commonUses,
  proTip,
  onFieldClick
}: Props) => {
  return <Box data-cy={`FieldItem_${fieldType}`}
  // height={54}
  border="1px solid" borderColor="border" borderRadius={1} onClick={onFieldClick} sx={{
    "&:hover": {
      backgroundColor: "action.hover",
      cursor: "pointer"
    }
  }} bgcolor="common.white" display="flex" alignItems="center" justifyContent="space-between" boxSizing="border-box" data-sentry-element="Box" data-sentry-component="FieldItem" data-sentry-source-file="FieldItem.tsx">
      <Tooltip enterDelay={1000} enterNextDelay={1000} title={<TooltipBody fieldName={fieldName} fieldType={fieldType} description={description} commonUses={commonUses} proTip={proTip} />} components={{
      Tooltip: Box
    }} followCursor data-sentry-element="Tooltip" data-sentry-source-file="FieldItem.tsx">
        <ListItem sx={{
        py: 1,
        px: 2
        // height: 54,
      }} data-sentry-element="ListItem" data-sentry-source-file="FieldItem.tsx">
          <ListItemIcon sx={{
          minWidth: "36px"
        }} data-sentry-element="ListItemIcon" data-sentry-source-file="FieldItem.tsx">
            <FieldIcon type={fieldType} data-sentry-element="FieldIcon" data-sentry-source-file="FieldItem.tsx" />
          </ListItemIcon>
          <ListItemText primary={fieldName} secondary={shortDescription} slotProps={{
          primary: {
            fontWeight: 700,
            variant: "body2",
            color: "text.primary"
          },
          secondary: {
            variant: "body3"
          }
        }} sx={{
          display: "flex",
          flexDirection: "column",
          my: 0
        }} data-sentry-element="ListItemText" data-sentry-source-file="FieldItem.tsx" />
        </ListItem>
      </Tooltip>
    </Box>;
};